import Vue from 'vue';
import Swal from "sweetalert2";
import appConfig from "@/app.config";
import i18n from '@/i18n';

export const swal = {
    error:(error, icon = 'error')=>{

        let status = 0
        let message = 'not found'

        let getTitle=()=>{
            return typeof error == 'string'? error : `Error Code : ${status}  Message : ${message}`
        };

        try {
            if(error.response.status)       status  = error.response.status
            if(error.response.data.message) message = error.response.data.message
        } catch(error) {message = error}

        Swal.fire({
            title: getTitle(),
            icon: icon,
            cancelButtonText: i18n.t('alert.error.cancelButtonText'),
            showConfirmButton: false,
            showCancelButton: true,
            position: "top",
        })
    },
    success:(msg = null)=>{
        Swal.fire({
            title: msg ?? i18n.t('alert.success.title'), 
            icon: "success",
            cancelButtonText: i18n.t('alert.success.cancelButtonText'),
            showConfirmButton: false,
            showCancelButton: true,
            position: "top",
            // confirmButtonColor: "#34c38f",
            // showCloseButton: true,
            // timer: 1500
            // footer: '<a href>Why do I have this issue?</a>',
            // imageUrl: 'https://placeholder.pics/svg/300x1500',
            // imageHeight: 100,
            // imageAlt: 'A tall image',
        })
    },
    async confirm(){
        let isConfirmed = await Vue.swal.fire({
            title: i18n.t('alert.confirm.title'),
            // text: "",
            icon: "warning",
            // type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#34c38f",
            cancelButtonColor: "#f46a6a",
            confirmButtonText: i18n.t('alert.confirm.confirmButtonText'),
            cancelButtonText: i18n.t('alert.confirm.cancelButtonText'),
        }).then(
        function (event) {
            return event.isConfirmed;
        })
        return isConfirmed === true
    },
    loading(title, message){
        Swal.fire({
            title: title??i18n.t('alert.loading.title'),
            html: message??'',
            icon: "",
            confirmButtonColor: "#74788d",
            confirmButtonText: i18n.t('alert.loading.confirmButtonText'),
            showConfirmButton: false,
            allowOutsideClick: false,
            onBeforeOpen: () => {
                Swal.showLoading();
          }
        })
    },
    close(){
        Swal.close()
    }
}

const noImage = require('@/assets/images/' + appConfig.noImage)
export const imageError = (e)=>{
    if(!e.target.hasAttribute('setErrorImage'))
        e.target.src = noImage
    e.target.setAttribute('setErrorImage', 'true')
}